import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./Home/AppHome.css";
import QRPage from "./Home/QRPage";
import RegistrationForm from "./Home/RegistrationForm";
import RegistrationForm2 from "./Home/RegistrationForm2";
import RegistrationFormWB from "./Home/RegistrationFormWB";
import MemberList from "./Home/MemberList";
import MemberListAdmin from "./Home/MemberListAdmin";
import MemberShipType from "./Home/MemberShipType";
import SystemManagement from "./Home/SystemManagement";
import PendingPayment from "./Home/PendingPayment";
import NewMemberHome from "./Home/NewMemberHome";
import MemberTable from "./Home/MemberTable";
import ExpenditurePage from "./Home/ExpenditurePage";
import Header from "./Home/Header";
import Header3 from "./Home/Header3";
import HeaderMember from "./Home/HeaderMember";
import MemberManagementPage from "./Home/MemberManagementPage";
import FinanceManagementPage from "./Home/FinanceManagementPage";
import PaymentListAdmin from "./Home/PaymentListAdmin";
import ExpenditureView from "./Home/ExpenditureView";
import DialogBox from "./Home/DialogBox";
import WelcomePage from "./Home/WelcomePage";
import SuccessPaymentInvoice from "./Home/SuccessPaymentInvoice";
import AddActivities from "./Home/AddActivities";
import ActivitySelection from "./Home/ActivitySelection";
import ActivitySummery from "./Home/ActivitySummery";
import FirstPayment from "./Home/FirstPayment";
import RegiWelcome from "./Home/RegiWelcome";
import AttenWelcome from "./Home/AttenWelcome";
import PaymentWarningPage from "./Home/PaymentWarningPage";
import MembershipExpired from "./Home/MembershipExpired";
import MainPhoto from "./Home/MainPhoto";
import NotFound from "./Home/NotFound";
import MonthlyReport from "./Home/MonthlyReport";
import PendingAllPayments from "./Home/PendingAllPayments";
import NetIncome from "./Home/NetIncome";
import BranchManagement from "./Home/BranchManagement";
import AssistantManager from "./Home/AssistantManager";


import DashBoard from "./Admin/DashBoard";
import Dashboard1 from "./Admin/Dashboard1";
import Profile from "./Admin/Profile";
import MemberPaymentManager from "./Home/MemberPaymentManager";
import PaymentView from "./Home/PaymentView";
import Attendance from "./Home/Attendance";
import AttendanceMember from "./Home/AttendanceMember";
import AttendanceMemberWB from "./Home/AttendanceMemberWB";
import Login from "./Home/Login";
import AttendanceManagement from "./Home/AttendanceManagement";
import IncomeManagement from "./Home/IncomeManagement";
import AttendanceHomeAdmin from "./Home/AttendanceHomeAdmin";

import AttendanceAssis from "./Assistant/AttendanceAssis";
import MemberPaymentManagerAssis from "./Assistant/MemberPaymentManagerAssis";
import RegistrationFormAssis from "./Assistant/RegistrationFormAssis";
import MemberListAssis from "./Assistant/MemberListAssis";
import ProtectedRoute from "./Home/ProtectedRoute";
import NewMemberHomes from "./Assistant/NewMemberHomes";
import Headers from "./Assistant/Headers";
import Header2 from "./Assistant/Header2";
import RegistrationForms from "./Assistant/RegistrationForms";
import MemberLists from "./Assistant/MemberLists";
import FirstPayments from "./Assistant/FirstPayments";
import Attendances from "./Assistant/Attendances";
import MemberAttendanceKB from "./Assistant/MemberAttendanceKB";
import RegistrationFormKB from "./Assistant/RegistrationFormKB";
import AttendanceHome from "./Assistant/AttendanceHome";
import RegistrationHome from "./Assistant/RegistrationHome";
import PendingAllPaymentAssis from "./Assistant/PendingAllPaymentAssis"
import PendingPaymentAssis from "./Assistant/PendingPaymentAssis"

function App() {
  return (
    <Router>
      <div style={{ padding: "10px", fontFamily: "Arial" }}>

        <Routes>
          <Route path="/" element={<MainPhoto />} />
          <Route path="/service/new-admission" element={<NewMemberHome />} />
          <Route path="/services/new-admission" element={<NewMemberHomes />} />

          <Route path="/registration" element={<RegistrationForm />} />
            <Route path="/registrations" element={<RegistrationForms />} />
            <Route path="/members-lists" element={<MemberLists />} />
            <Route path="/first-payments" element={<FirstPayments />} />

            <Route path="/services/attendance" element={<Attendances />} />

          <Route path="/registration-member" element={<RegistrationForm2 />} />
          <Route path="/registration-member_WB" element={<RegistrationFormWB />} />
          <Route path="/summery125" element={<ActivitySelection />} />
          <Route path="/service/attendance" element={<AttendanceHomeAdmin />} />
            <Route path="/service/settings" element={<SystemManagement/>} />
          <Route path="/service/payment" element={<MemberPaymentManager />} />
          <Route path="/membership-management" element={<MemberShipType />} />
          <Route path="/income-management" element={<PaymentView />} />
          <Route path="/service/QR-code" element={<QRPage />} />
          <Route path="/members-list" element={<MemberList />} />
          <Route path="/first-payment" element={<FirstPayment />} />
          <Route path="/attendance-management" element={<AttendanceManagement />} />
          <Route path="/member-management" element={<MemberListAdmin />} />
          <Route path="/service/reports" element={<IncomeManagement />} />


          <Route path="/pending-payment" element={<PendingPayment />} />
          <Route path="/expenditure-management" element={<ExpenditurePage />} />
          <Route path="/service/member-management" element={<MemberManagementPage />} />
          <Route path="/service/finance-management" element={<FinanceManagementPage />} />
          <Route path="/service/branch-management" element={<BranchManagement />} />
          <Route path="/service/assistant-management" element={<AssistantManager />} />
          <Route path="/payment-management" element={<PaymentListAdmin />} />
          <Route path="/expenditure-analyze" element={<ExpenditureView />} />
          <Route path="/mark-attendance" element={<AttendanceMember />} />
          <Route path="/mark-attendance_WB" element={<AttendanceMemberWB />} />
          <Route path="/add-activities" element={<AddActivities />} />
          <Route path="/member-application" element={<MemberTable />} />
          <Route path="/pending-all-payment" element={<PendingAllPayments />} />


          <Route path="/welcome/:memberId" element={<WelcomePage />} />
          <Route path="/success-payment/:billNo" element={<SuccessPaymentInvoice />} />
          <Route path="/payment-slip/:billNo" element={<SuccessPaymentInvoice />} />
          <Route path="/service/activity" element={<ActivitySummery />} />
          <Route path="/regi-successful" element={<RegiWelcome />} />
          <Route path="/mark-successful" element={<AttenWelcome />} />
          <Route path="/payment-warning" element={<PaymentWarningPage />} />
         <Route path="/membership-expired" element={<MembershipExpired />} />
          <Route path="/nml" element={<MonthlyReport />} />
          <Route path="/nmlnet" element={<NetIncome />} />


          <Route path="/assis/members-list" element={<MemberListAssis />} />
          <Route path="/assis/payment" element={<MemberPaymentManagerAssis />} />
          <Route path="/assis/attendance_WB" element={<Attendances />} />
          <Route path="/assis/registration_WB" element={<RegistrationForms />} />
          <Route path="/assis/attendance_KB" element={<MemberAttendanceKB />} />
          <Route path="/assis/registration_KB" element={<RegistrationFormKB />} />
          <Route path="/assis/AttendanceHome" element={<AttendanceHome />} />
          <Route path="/assis/PayReminder" element={<PendingPaymentAssis />} />
          <Route path="/assis/AttReminder" element={<PendingAllPaymentAssis />} />
              <Route path="/assis/RegistrationHome" element={<RegistrationHome />} />




          <Route path="/dashboard-admin" element={<Dashboard1 />} />
          <Route path="/dashboard" element={<DashBoard/>} />
          <Route path="/lfploginadmin" element={<Login />} />
          <Route path="*" element={<NotFound />} />

        </Routes>
      </div>
    </Router>
  );
}

export default App;

<Route
  path="/membership-management"
  element={
    <ProtectedRoute allowedRoles={["ADMIN"]}>
      <MemberShipType />
    </ProtectedRoute>
  }
/>





